export function transformData(data: any) {
  const result: any = {}
  let screenCounter = 1
  let lastScreen = ''

  Object.values(data).forEach((stage: any) => {
    Object.keys(stage).forEach(key => {
      if (!key || !stage?.[key]) return

      const screenPrefix = key.match(/screen_\d+/)?.[0] || ''

      if (screenPrefix !== lastScreen) {
        lastScreen = screenPrefix
        screenCounter++
      }

      const newKey = key.replace(/screen_\d+/, `screen_${screenCounter - 1}`)
      result[newKey] = stage[key]
    })
  })

  return result
}
